import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","height":"100%"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  style: {},
  id: "sidebar"
}, [
  /*#__PURE__*/_createElementVNode("select", { id: "modeSelect" }, [
    /*#__PURE__*/_createElementVNode("option", {
      value: "",
      selected: ""
    }, "Play"),
    /*#__PURE__*/_createElementVNode("option", null, "Edit"),
    /*#__PURE__*/_createElementVNode("option", null, "Computer Solve")
  ])
], -1)
const _hoisted_3 = {
  id: "contentContainer",
  style: {"max-height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopBoard = _resolveComponent("PopBoard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PopBoard)
    ])
  ]))
}